import { render, staticRenderFns } from "./AddProductPopup.vue?vue&type=template&id=4ce6d7e4&"
import script from "./AddProductPopup.vue?vue&type=script&lang=js&"
export * from "./AddProductPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports